/**
 * État du planning v2 : semaine, jour choisi (mobile) et filtres.
 *
 * En mémoire seulement (pas de localStorage) : l'aller-retour planning → fiche cours → planning garde la semaine
 * et les filtres ; un nouveau chargement de la page repart de la semaine courante et des filtres par défaut (la
 * marque du site en vue multi-marques, SPEC PL7). Indépendant du store v1 (stores/classes.ts, persisté) : les filtres
 * v2 portent des clés « site:id » multi-marques.
 */
import { create } from 'zustand';
import type { PlanningFilters } from '../../lib/planning/filters';
import { weekStartOf } from '../../lib/planning/week';

interface PlanningState {
  weekStart: Date;
  /** Jour choisi dans le sélecteur mobile ; null = jour par défaut de la semaine. */
  selectedDay: Date | null;
  /**
   * Filtres choisis ; null = filtres par défaut (lib/planning/filters.ts defaultFilters), tant que le visiteur n'a
   * rien choisi et après « Effacer ». La marque par défaut n'est connue qu'au rendu (vue multi-marques ou non, selon
   * les réglages puis la réponse de class/planning) : elle n'est pas figée ici.
   */
  filters: PlanningFilters | null;
  /** Dernière route dont les pré-filtres ont été appliqués (cf. usePlanningRoute). */
  appliedPath: string | null;
}

export const usePlanningStore = create<PlanningState>()(() => ({
  weekStart: weekStartOf(new Date()),
  selectedDay: null,
  filters: null,
  appliedPath: null,
}));
